import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from 'components/Button/Button';
import OTPInput from 'components/form/OTPInput';
import useTimer from 'hooks/useTimer';
import React, { useRef } from 'react';
import * as authService from 'services/auth.service';
import toast, { snack } from 'utils/toast';

const LoginMFA = ({
  channel,
  message,
  username,
  deviceId,
  onSubmit,
  loading,
}) => {
  const { timer, start, resendDisabled } = useTimer();
  const otpRef = useRef();

  const handleSubmit = (val) => {
    onSubmit({ verify_code: val }).then(() => {
      otpRef.current?.clear();
    });
  };

  const onResend = async () => {
    try {
      const resp = await authService.resendVerificationCode(username, deviceId);
      snack.success(resp.msg);
      start();
    } catch (e) {
      toast.error(e.message);
    }
  };

  if (channel === 'totp') {
    return (
      <>
        <Typography paragraph>
          To continue, please enter the 6-digit verification code from your
          authenticator app.
        </Typography>
        <OTPInput
          isNumberInput
          autoFocus
          disabled={loading}
          sx={{ mt: 3, mx: 'auto' }}
          length={6}
          onComplete={handleSubmit}
          ref={otpRef}
        />
      </>
    );
  }

  const codeLength = 6;

  return (
    <>
      <Typography paragraph>
        To continue, please enter the {codeLength}-digit verification code sent
        to your registered {channel === 'email' ? 'email' : 'phone number'}.
      </Typography>
      <OTPInput
        isNumberInput
        autoFocus
        disabled={loading}
        sx={{ mt: 3, mx: 'auto' }}
        length={codeLength}
        onComplete={handleSubmit}
        ref={otpRef}
      />
      <Box textAlign="center" mt={2}>
        {resendDisabled ? (
          <Typography variant="caption">
            You can request for code again in {timer} seconds
          </Typography>
        ) : (
          <Button variant="link" onClick={onResend}>
            Resend Code
          </Button>
        )}
      </Box>
    </>
  );
};

export default LoginMFA;
